import { PortalStatusIcon, PortalStatusProps } from "@/Common/Components/Portal/PortalStatusIcon";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { PortalCommunicationComposite } from "@/Common/Models/PortalCommunication/PortalCommunicationComposite";
import { MedicalItemCard } from "@/DesignSystem/Molecules/MedicalItemCard/MedicalItemCard";

interface IPortalCommunicationsThreadItemComponentProps {
    threadItem: PortalCommunicationComposite;
    isSelected: boolean;
    onClick: (sharedItemId: string) => void;
}

export function PortalCommunicationsThreadItemComponent(props: Readonly<IPortalCommunicationsThreadItemComponentProps>): JSX.Element {
    const formatDate = (date: string): string => new Date(date).format("YYYY-MM-DD");
    const getPortalButtonProps = (): PortalStatusProps => PortalHelper.getPortalButtonPropsForSyncStatus(props.threadItem.latestEmployeeSharedItemMessage.Status, props.threadItem.sharedItem.IncludeLinkedItem);

    const showPortalButton = props.threadItem.latestEmployeeSharedItemMessage != null;
    const lastMessage = props.threadItem.getLatestSharedItemMessage();

    const fromName = lastMessage?.IsFromPatient
        ? NameHelper.formatFullName(lastMessage.PatientFirstName, lastMessage.PatientLastName, lastMessage.PatientPreferredName)
        : cacheStore.GetCliniciansPersonsByContactId(lastMessage?.SentByContactId ?? props.threadItem.sharedItem.InitiatedByContactId)?.NameWithPrefix;

    const validateIsSharedItemRead = (): boolean => {
        const latestPatientMessageDateCreated = props.threadItem?.latestPatientSharedItemMessage?.DateCreated;
        const sharedItemDateReadByUser = props.threadItem?.sharedItem?.DateReadByUser;

        if (!latestPatientMessageDateCreated) {
            return true;
        }

        if (!sharedItemDateReadByUser) {
            return false;
        }

        const sharedItemDateReadByUserDate = new Date(sharedItemDateReadByUser);
        const latestPatientSharedItemMessageDateCreated = new Date(latestPatientMessageDateCreated);

        return latestPatientSharedItemMessageDateCreated < sharedItemDateReadByUserDate;
    };

    return (
        <MedicalItemCard
            id={props.threadItem.sharedItem.SharedItemId}
            status={lastMessage?.IsFromPatient ? "received" : "sent"}
            date={formatDate((lastMessage ? lastMessage.DateCreated : props.threadItem.sharedItem.DateCreated).toString())}
            title={props.threadItem.sharedItem.Subject ?? ""}
            titleCounter={props.threadItem.numberOfSharedItemMessages.toString()}
            names={[fromName]}
            descriptions={[lastMessage?.Text]}
            onClick={() => props.onClick(props.threadItem.sharedItem.SharedItemId)}
            selected={props.isSelected}
            readStatus={validateIsSharedItemRead() ? "read" : "unread"}
            locale={sessionStore.locale}
        >
            {showPortalButton && (
                <PortalStatusIcon
                    icon="share"
                    {...getPortalButtonProps()}
                />
            )}
        </MedicalItemCard>
    );
}
